const AccordionButton = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_593_4472)">
        <rect width="24" height="24" rx="12" fill="#F5F5F5" />
        <path
          d="M7 10L12 15L17 10"
          stroke="#202124"
          stroke-width="1.88571"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_593_4472">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(24) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccordionButton;
